var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVoltage = function SvgVoltage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.889 0C3.396 0 3 .446 3 1v1h3.556V1c0-.554-.397-1-.89-1zM11.889 0C11.397 0 11 .446 11 1v1h3.556V1c0-.554-.397-1-.89-1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.7,
    height: 10.7,
    x: 0.65,
    y: 2.65,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 0.7,
    rx: 1.35
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVoltage);
export default ForwardRef;